var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Box",style:({ height: _vm.height === 'auto' ? 'auto' : '620px' })},[_c('div',{staticClass:"introTitle"},[_c('img',{attrs:{"src":require("../../../../assets/img/renyiOverview/jiantou.png")}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"line"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }